// sections.config.js
// Section order per Light Call subsite (regression | reiki | mentorship).
// Section names must match keys in App.jsx sectionMap.

export const SECTIONS_ORDER_REGRESSION = [
  'HeroV3Section',
  'ServicesSection',
  'WelcomeSection',
  'ResearcherQuotesSection',
  'WhatIsSection',
  'StatementSection',
  'TestimonialCarousel',
  'ResearchersSection',
  'PodcastVideoSection',
  'ForWhomSection',
  'AboutSection',
  'QuoteSection',
  'ProcessSection',
  'PodcastSection',
  'CaseStudiesSection',
  'BookingSection',
  'FAQSection',
  'ReferencesSection',
  'CtaImageSection',
]

/**
 * Mentorship — Elementor-style universal templates (archive content order).
 * contentKey instances: FullCTA_*, Body_*, ForWhom_*, Statement_*
 */
export const SECTIONS_ORDER_MENTORSHIP = [
  'HeroImageSection',
  'WhatIsSection',
  'FullCTA_counterbalance',
  'FullCTA_puzzle',
  'Statement_freedom',
  'Body_storyPartA',
  'Statement_storyQuote',
  'Body_storyPartB',
  'FullCTA_brick',
  'QuoteSection',
  'ProcessSection',
  'CaseStudiesSection',
  'FullCTA_outcomesIntro',
  'ForWhom_outcomesList',
  'AboutSection',
  'ForWhomSection',
  'StatementSection',
  'FAQSection',
  'BookingSection',
  'FinalCTASection',
]

/** Reiki: reuse regression order until dedicated page is refined */
export const SECTIONS_ORDER_REIKI = [
  'HeroV3Section',
  'ServicesSection',
  'WelcomeSection',
  'WhatIsSection',
  'StatementSection',
  'ForWhomSection',
  'AboutSection',
  'ProcessSection',
  'BookingSection',
  'FAQSection',
  'CtaImageSection',
]

export const SECTIONS_BY_SITE = {
  regression: SECTIONS_ORDER_REGRESSION,
  mentorship: SECTIONS_ORDER_MENTORSHIP,
  reiki: SECTIONS_ORDER_REIKI,
}

/** @deprecated use getSectionsOrder(site) — kept for older imports */
export const SECTIONS_ORDER = SECTIONS_ORDER_REGRESSION

export function getSectionsOrder(site = 'regression') {
  return SECTIONS_BY_SITE[site] || SECTIONS_ORDER_REGRESSION
}
